export const formatToCurrency = (
  numberFixed: string,
  includeCurrencySymbol: string,
) => {
  let result;

  if (numberFixed.endsWith('00')) {
    result = numberFixed.toString().replace('.00', '');
  } else {
    result = numberFixed;
  }

  if (includeCurrencySymbol) {
    result = `$${result}`;
  }

  return result;
};

export const isOdd = (num: number): boolean => {
  return num % 2 !== 0;
};

export const getFee = (amount: string, showTotalWithFee: boolean): string => {
  if (amount) {
    const parsedAmount = parseFloat(amount);
    if (parsedAmount > 0) {
      const totalWithFee = (parsedAmount + 1.3) / 0.971;
      const fee = totalWithFee - parsedAmount;
      if (showTotalWithFee) return totalWithFee.toFixed(2);
      return fee.toFixed(2);
    }
  }
  return '0.00';
};
